/**
 * ContinuationPrompt - User prompt for continuing long voice responses
 *
 * Displays when a voice response is truncated due to length limits.
 * Allows user to continue listening to the next chunk or stop playback.
 */

import React from 'react';
import styles from './ContinuationPrompt.module.scss';

interface IContinuationPrompt {
  remainingChars: number;
  onContinue: () => void;
  onStop: () => void;
}

const ContinuationPrompt: React.FC<IContinuationPrompt> = ({
  remainingChars,
  onContinue,
  onStop
}) => {
  return (
    <div className={styles.continuationPrompt}>
      <div className={styles.promptContent}>
        <p className={styles.promptMessage}>
          Response continues ({remainingChars.toLocaleString()} more characters).
          <br />
          Continue reading?
        </p>
        <div className={styles.buttonGroup}>
          <button
            onClick={onStop}
            className={`${styles.button} ${styles.buttonSecondary}`}
            aria-label="Stop voice playback"
          >
            No, Stop
          </button>
          <button
            onClick={onContinue}
            className={`${styles.button} ${styles.buttonPrimary}`}
            aria-label="Continue voice playback"
            autoFocus
          >
            Yes, Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContinuationPrompt;
